import { ClassEnum } from '@/constants/enum';
import styled from 'styled-components';

export interface IHeaderRadioLabelProps {
  color: string;
  backgroundColor: string;
  borderColor?: string;
  borderRadius: string;
  fontWeight: number;
  flexDirection: 'row' | 'row-reverse' | 'column';
  justifyContent: string;
  hoverBackgroundColor: string;
  isChecked: boolean;
  borderColorHover?: string;
  colorHover?: string;
  className?: string;
}

export const StyledHeaderRadioLabel = styled.label<IHeaderRadioLabelProps>`
  color: ${props => props.color};
  background-color: ${props => props.backgroundColor};
  border-color: ${props => props.borderColor};
  border-radius: ${props => props.borderRadius};
  font-weight: ${props => props.fontWeight};
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};

  &:hover {
    background-color: ${props => !props.isChecked ? props.hoverBackgroundColor : props.backgroundColor};
    color: ${props => !props.isChecked ? props.colorHover : props.color};
    border-color: ${props => !props.isChecked ? props.borderColorHover : props.borderColor};

    .${ClassEnum.HeaderRadioLabelText} {
      color: ${props => !props.isChecked ? props.colorHover : props.color};
    }
  }


`;